module.exports = __webpack_public_path__ + "img/emoji-peach-240x240.824e5ea6.png";